/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Postfachort1Inputs */

const de__field_postfachort1 = /** @type {(inputs: _Field_Postfachort1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Postfach Ort`)
};

/**

* @param {_Field_Postfachort1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_postfachort1 = /** @type {((inputs?: _Field_Postfachort1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Postfachort1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_postfachort1(inputs)
});
export { _field_postfachort1 as "_field_postfachOrt" }